import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { label: 'TOP', path: '/' },
    { label: 'Our Vision（私たちの目指す世界）', path: '/vision' },
    { label: 'Business（事業紹介）', path: '/business' },
    { label: 'Technology（テクノロジーと強み）', path: '/technology' },
    { label: 'Use Case / DX効果（自治体・企業向けの導入メリット）', path: '/usecase' },
    { label: 'Company（会社概要）', path: '/company' },
    { label: 'Contact（お問い合わせ）', path: '/contact' }
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-gray-200">
      <div className="px-6 md:px-20 py-6">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <div className="w-10 h-10 flex items-center justify-center bg-blue-900 rounded-lg">
              <i className="ri-global-line text-xl text-white"></i>
            </div>
            <span className="text-xl font-bold text-blue-900 tracking-tight">
              GAIA LIBRARY
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm font-medium transition-colors duration-300 cursor-pointer relative pb-1 whitespace-nowrap ${
                  isActive(item.path)
                    ? 'text-blue-600 after:absolute after:bottom-0 after:left-0 after:w-full after:h-0.5 after:bg-blue-600'
                    : 'text-blue-900 hover:text-blue-600 hover:after:absolute hover:after:bottom-0 hover:after:left-0 hover:after:w-full hover:after:h-0.5 hover:after:bg-blue-600'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-blue-900 cursor-pointer"
            aria-label="メニュー"
          >
            <i className={`text-2xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="lg:hidden fixed inset-0 top-[73px] bg-white z-40 overflow-y-auto">
          <nav className="flex flex-col items-center justify-center min-h-full py-12 px-6">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setIsMenuOpen(false)}
                className={`text-lg font-medium py-4 transition-colors duration-300 cursor-pointer ${
                  isActive(item.path) ? 'text-blue-600' : 'text-blue-900 hover:text-blue-600'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
